export enum ServiceCardTag {
  Recommended = "Recommended",
  Suggested = "Suggested",
  Added = "Added",
}
